import React from "react";
import { useNavigate } from "react-router-dom";
import product1 from "../../assets/product1.jpg";
import product2 from "../../assets/product2.jpg";
import Header from "../layout/Header";

const ProductSection = () => {
  const navigate = useNavigate();

  return (
    <div>
      <Header />

      {/* === PRODUCT SELECTION === */}
      <section
        style={{
          backgroundColor: "white",
          padding: "80px 0",
          textAlign: "center",
        }}
      >
        <h2
          style={{
            fontFamily: "Georgia, serif",
            fontSize: "1.3rem",
            fontWeight: "600",
            marginBottom: "2rem",
            color: "#111",
          }}
        >
          DISCOVER YOUR SIGNATURE SCENT
        </h2>

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "flex-start",
            gap: "100px",
            flexWrap: "wrap",
          }}
        >
          {/* === Product 1: Rowdy Party === */}
          <div
            onClick={() => navigate("/product/rowdy-party")}
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              width: "200px",
              cursor: "pointer",
              transition: "transform 0.3s ease",
            }}
          >
            <img
              src={product1}
              alt="Rowdy Party"
              style={{
                width: "270px",
                height: "350px",
                objectFit: "cover",
                borderRadius: "8px",
                boxShadow: "0 4px 8px rgba(0,0,0,0.15)",
                transition: "transform 0.3s ease",
              }}
              onMouseOver={(e) =>
                (e.currentTarget.style.transform = "scale(1.05)")
              }
              onMouseOut={(e) =>
                (e.currentTarget.style.transform = "scale(1)")
              }
            />
            <h3
              style={{
                marginTop: "20px",
                fontFamily: "Georgia, serif",
                fontSize: "1.1rem",
                color: "#111",
              }}
            >
              Rowdy Party
            </h3>
            <p style={{ fontSize: "0.9rem", color: "#555" }}>50 ml</p>
          </div>

          {/* === Product 2: Serene Bliss === */}
          <div
            onClick={() => navigate("/product/serene-bliss")}
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              width: "200px",
              cursor: "pointer",
              transition: "transform 0.3s ease",
            }}
          >
            <img
              src={product2}
              alt="Serene Bliss"
              style={{
                width: "270px",
                height: "350px",
                objectFit: "cover",
                borderRadius: "8px",
                boxShadow: "0 4px 8px rgba(0,0,0,0.15)",
                transition: "transform 0.3s ease",
              }}
              onMouseOver={(e) =>
                (e.currentTarget.style.transform = "scale(1.05)")
              }
              onMouseOut={(e) =>
                (e.currentTarget.style.transform = "scale(1)")
              }
            />
            <h3
              style={{
                marginTop: "20px",
                fontFamily: "Georgia, serif",
                fontSize: "1.1rem",
                color: "#111",
              }}
            >
              Serene Bliss
            </h3>
            <p style={{ fontSize: "0.9rem", color: "#555" }}>50 ml</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ProductSection;
